import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const isExternalUrl = (url: string) => {
  return new RegExp(/^(https?:)?\/\//).test(url);
};

const SmartRedirect = ({ to }: { to: string }) => {
  if (isExternalUrl(to)) {
    window.location.href = to;
    return <></>
  } else {
    return <Navigate to={to} replace />;
  }

};

export default SmartRedirect;
